import * as React from "react";
import { Stack } from "@mui/material";
import ReportTable from "../tables/ReportTable";
import ReportsFilter from "../filters/ReportsFilter";

function Reports() {
    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ReportsFilter/>
            <ReportTable/>
        </Stack>
    )
}

export default Reports;